import React from "react";
import ReactFormInputValidation from "react-form-input-validation";
import emailjs from 'emailjs-com';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Recaptcha from 'react-recaptcha';

class ContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                sender_name: "",
                sender_email: "",
                sender_phone: "",
                message: "",
            },
            errors: {},
            open: false,
            error: false,
            recaptchaLoad: false,
            isVerified: false,
        };

        this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
        this.verifiedRecaptcha = this.verifiedRecaptcha.bind(this);

        this.form = new ReactFormInputValidation(this);
        this.form.useRules({
            sender_name: "required",
            sender_email: "required|email",
            sender_phone: "required|numeric|digits_between:10,12",
            message: "required",
        });
        this.form.onformsubmit = (fields) => {
            const { recaptchaLoad, isVerified } = this.state;

            if (recaptchaLoad && isVerified) {
                const templateParams = {
                    sender_name: fields.sender_name,
                    sender_email: fields.sender_email,
                    sender_phone: fields.sender_phone,
                    message: fields.message,
                };

                emailjs.send('service_oywhdiw', 'template_n8n7nsp', templateParams, 'user_2fSXXfAxsrD9QoGQEZEJo')
                    .then((result) => {
                        console.log(result.text);
                    }, (error) => {
                        console.log(error.text);
                    });

                this.setState({
                    fields: {
                        sender_name: "",
                        sender_email: "",
                        sender_phone: "",
                        message: "",
                    },
                    error: false,
                    open: true,
                });
            } else {
                this.setState({
                    error: true,
                });
            }
        }
    }

    recaptchaLoaded() {
        this.setState({ recaptchaLoad: true });
    }

    verifiedRecaptcha(response) {
        if (response) {
            this.setState({ isVerified: true });
        }
    }

    render() {
        return (<React.Fragment>

            <Grid container direction="column">
                <Grid item >
                    <Collapse in={this.state.error}>
                        <Alert severity="error" style={{ fontSize: "15px", marginBottom: "15px" }}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        this.setState({ error: false });
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            Please check Captcha
                        </Alert>
                    </Collapse>
                </Grid>
                <Grid item >
                    <Collapse in={this.state.open}>
                        <Alert style={{ fontSize: "15px", marginBottom: "15px" }}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        this.setState({ open: false });
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            Thank you, your message has been received
                        </Alert>
                    </Collapse>
                </Grid>
                <Grid item >
                    <Typography component="h1" variant="h2" gutterBottom>CONTACT US</Typography>
                </Grid>
                <Grid item >
                    <Typography variant="h1" paragraph>Please Fill In The Form</Typography>
                </Grid>

                <form onSubmit={this.form.handleSubmit} noValidate autoComplete="off" >
                    {/* <input type="hidden" name="contact_number" /> */}

                    <Grid container direction="column" spacing={3}>
                        <Grid item>
                            <Grid item style={{ width: "100%" }}>
                                <TextField label="Full Name" name="sender_name" variant="outlined" fullWidth onBlur={this.form.handleBlurEvent}
                                    onChange={this.form.handleChangeEvent}
                                    value={this.state.fields.sender_name}
                                    error={Boolean(this.state.errors.sender_name)}
                                    helperText={this.state.errors.sender_name}
                                />
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="space-between" spacing={2}>


                                <Grid item style={{ width: "50%" }}>
                                    <TextField label="Email" name="sender_email" type="email" variant="outlined" fullWidth
                                        onBlur={this.form.handleBlurEvent}
                                        onChange={this.form.handleChangeEvent}
                                        value={this.state.fields.sender_email}
                                        error={Boolean(this.state.errors.sender_email)}
                                        helperText={this.state.errors.sender_email}
                                    />
                                </Grid>

                                <Grid item style={{ width: "50%" }}>
                                    <TextField label="Phone" name="sender_phone" type="number" variant="outlined" fullWidth onBlur={this.form.handleBlurEvent}
                                        onChange={this.form.handleChangeEvent}
                                        value={this.state.fields.sender_phone}
                                        error={Boolean(this.state.errors.sender_phone)}
                                        helperText={this.state.errors.sender_phone}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <TextField label="Message" name="message" multiline rows={7} variant="outlined" fullWidth
                                onChange={this.form.handleChangeEvent}
                                value={this.state.fields.message}
                                error={Boolean(this.state.errors.message)}
                                helperText={this.state.errors.message}
                            />
                        </Grid>

                        <Grid item>
                            <Button type="submit" variant="contained" color="primary">
                                Send Message
                            </Button>
                        </Grid>
                        <Grid item>
                            <Recaptcha
                                sitekey="6Ld2CY0aAAAAAFXjNgIyVrMha96j3LKg31TuRmps"
                                render="explicit"
                                onloadCallback={this.recaptchaLoaded}
                                verifyCallback={this.verifiedRecaptcha}
                            />
                        </Grid>
                    </Grid>





                </form>
            </Grid>

        </React.Fragment>)
    }
}

export default ContactForm;